import React from 'react';

import './AnalyticsNetworkBusinessOverview.scss';

import Tooltips from '../../atoms/Tooltip/Tooltip';

// import * as moment from 'moment';

const AnalyticsNetworkBusinessOverview = ({ loading, responseData, overallDataSetType }) => {
  return (
    <>
      <div className="tmx-analyticsNetworkBusinessOverview__clearedGrid tmx-analyticsNetworkBusinessOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New newsroom accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.users?.total_network_users}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                Total network users
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}
        {loading ? (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Users engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopTitle">
                {responseData?.users?.biz_engaged}
              </h1>
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Engaged Business orgs
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Newsrooms engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopTitle">
                {responseData?.users?.biz_users_engaged}
              </h1>
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Engaged Business users
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New user accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopTitle">
                {responseData?.users?.biz_new}
              </h1>
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                New Business users
                <br />
                (Unique)
              </h1>
            </Tooltips>
          </div>
        )}
      </div>
      {overallDataSetType === 'This Week' || overallDataSetType === 'This Month' ? (
        <div className="tmx-analyticsNetworkNewsroomOverview__clearedGrid">
          {loading && overallDataSetType === 'This Week' ? (
            <>
              <div className="tmx-analyticsDashboard__clearedBubble">
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphTitle"></div>
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphSubTitle"></div>
              </div>
            </>
          ) : overallDataSetType === 'This Week' ? (
            <div className="tmx-analyticsNetworkNewsroomOverview__iframeItem">
              <iframe
                src="https://embed.tmxdata.io/public/question/7f076503-9882-413b-9ffb-aead06eecc85"
                frameborder="0"
                width="100%"
                height="100%"
                title="aead06eecc85"
                allowtransparency></iframe>
            </div>
          ) : null}

          {loading && overallDataSetType === 'This Month' ? (
            <div className="tmx-analyticsDashboard__clearedBubble">
              <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphTitle"></div>
              <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphSubTitle"></div>
            </div>
          ) : overallDataSetType === 'This Month' ? (
            <div className="tmx-analyticsNetworkNewsroomOverview__iframeItem">
              <iframe
                src="https://embed.tmxdata.io/public/question/9d1dd776-df97-4e81-b646-91ad1e7eb417"
                frameborder="0"
                width="100%"
                height="100%"
                title="91ad1e7eb417"
                allowtransparency></iframe>
            </div>
          ) : null}
        </div>
      ) : null}
      <div className="tmx-analyticsNetworkNewsroomOverview__topTextContainer">
        <div className="tmx-analyticsNetworkNewsroomOverview__topTextContainerLeft">
          <h1 className="tmx-analyticsNetworkNewsroomOverview__topTextTitle">
            Mission-critical KPIs
          </h1>
          <h1 className="tmx-analyticsNetworkNewsroomOverview__topTextSubTitle">
            This information is confidential.{' '}
          </h1>
        </div>
      </div>
      <div className="tmx-analyticsNetworkNewsroomOverview__clearedGrid tmx-analyticsNetworkNewsroomOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Users engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.messenger?.average_reply_time_minutes}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Average reply time
                <br />
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Newsrooms engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle">
                {responseData?.messenger?.requests_no_reply_30min}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                No reply in 30 min
                <br />
                {/* (Unique) */}
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkNewsroomOverview__titleMock tmx-analyticsNetworkNewsroomOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkNewsroomOverview__clearedBubble tmx-analyticsNetworkNewsroomOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New user accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle tmx-analyticsNetworkNewsroomOverview__basicInfoTopTitle--variation">
                {responseData?.messenger
                  ? Object.keys(responseData?.messenger?.requests_no_reply_by_category)[0]
                  : null}
              </h1>
              <h1 className="tmx-analyticsNetworkNewsroomOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                No reply by category
                <br />
              </h1>
            </Tooltips>
          </div>
        )}
      </div>
      <div className="tmx-analyticsNetworkBusinessOverview__topTextContainer">
        <div className="tmx-analyticsNetworkBusinessOverview__topTextContainerLeft">
          <h1 className="tmx-analyticsNetworkBusinessOverview__topTextTitle">
            TMX messenger business KPIs
          </h1>
          <h1 className="tmx-analyticsNetworkBusinessOverview__topTextSubTitle">
            This information is confidential.{' '}
          </h1>
        </div>
      </div>
      {overallDataSetType === 'This Week' || overallDataSetType === 'This Month' ? (
        <div className="tmx-analyticsNetworkNewsroomOverview__clearedGrid">
          {loading && overallDataSetType === 'This Week' ? (
            <>
              <div className="tmx-analyticsDashboard__clearedBubble">
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphTitle"></div>
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphSubTitle"></div>
              </div>
              <div className="tmx-analyticsDashboard__clearedBubble">
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphTitle"></div>
                <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphSubTitle"></div>
              </div>
            </>
          ) : overallDataSetType === 'This Week' ? (
            <div className="tmx-analyticsNetworkNewsroomOverview__iframeItem">
              <iframe
                src="https://embed.tmxdata.io/public/question/68de7852-f09d-47c0-b40a-4f59217f3bcc"
                frameborder="0"
                width="100%"
                height="100%"
                title="4f59217f3bcc"
                allowtransparency></iframe>
            </div>
          ) : null}

          {loading && overallDataSetType === 'This Month' ? (
            <div className="tmx-analyticsDashboard__clearedBubble">
              <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphTitle"></div>
              <div className="tmx-analyticsDashboard__titleMock tmx-analyticsDashboard__titleMock--graphSubTitle"></div>
            </div>
          ) : overallDataSetType === 'This Month' ? (
            <div className="tmx-analyticsNetworkNewsroomOverview__iframeItem">
              <iframe
                src="https://embed.tmxdata.io/public/question/994faa0d-9e75-4068-b4fc-27c2e655f357"
                frameborder="0"
                width="100%"
                height="100%"
                title="27c2e655f357"
                allowtransparency></iframe>
            </div>
          ) : null}
        </div>
      ) : null}
      <div className="tmx-analyticsNetworkBusinessOverview__clearedGrid tmx-analyticsNetworkBusinessOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Users engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopTitle">
                {responseData?.messenger?.br_count}
              </h1>
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Total Business replies
                <br />
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="Newsrooms engaging with TMX within a specific amount of time."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopTitle">
                {responseData?.messenger?.br_users}
              </h1>
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Total Business replie users
                <br />
                {/* (Unique) */}
              </h1>
            </Tooltips>
          </div>
        )}
      </div>
      <div className="tmx-analyticsNetworkBusinessOverview__topTextContainer">
        <div className="tmx-analyticsNetworkBusinessOverview__topTextContainerLeft">
          <h1 className="tmx-analyticsNetworkBusinessOverview__topTextTitle">
            Subscription Preferences
          </h1>
          <h1 className="tmx-analyticsNetworkBusinessOverview__topTextSubTitle">
            This information is confidential.{' '}
          </h1>
        </div>
      </div>
      <div className="tmx-analyticsNetworkBusinessOverview__clearedGrid tmx-analyticsNetworkBusinessOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New user accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopTitle">
                {responseData?.subscription_preferences?.non_newsroom_realtime}
              </h1>
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Total Realtime
                <br />
                {/* (Unique) */}
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New newsroom accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopTitle">
                {responseData?.subscription_preferences?.non_newsroom_digest_am}
              </h1>
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Total Morning digest
                <br />
                {/* (Unique) */}
              </h1>
            </Tooltips>
          </div>
        )}
        {loading ? (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New newsroom accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopTitle">
                {responseData?.subscription_preferences?.non_newsroom_digest_pm}
              </h1>
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Total Afternoon digest
                <br />
                {/* (Unique) */}
              </h1>
            </Tooltips>
          </div>
        )}
      </div>
      <div className="tmx-analyticsNetworkBusinessOverview__topTextContainer">
        <div className="tmx-analyticsNetworkBusinessOverview__topTextContainerLeft">
          <h1 className="tmx-analyticsNetworkBusinessOverview__topTextTitle">TMX pitches KPIs</h1>
          <h1 className="tmx-analyticsNetworkBusinessOverview__topTextSubTitle">
            This information is confidential.{' '}
          </h1>
        </div>
      </div>
      <div className="tmx-analyticsNetworkBusinessOverview__clearedGrid tmx-analyticsNetworkBusinessOverview__clearedGrid--top">
        {loading ? (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New user accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopTitle">
                {responseData?.messenger?.bp_count}
              </h1>
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Total Business pitches
                <br />
                {/* (Unique) */}
              </h1>
            </Tooltips>
          </div>
        )}

        {loading ? (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--number"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--subTitle"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
            <div className="tmx-analyticsNetworkBusinessOverview__titleMock tmx-analyticsNetworkBusinessOverview__titleMock--bar"></div>
          </div>
        ) : (
          <div className="tmx-analyticsNetworkBusinessOverview__clearedBubble tmx-analyticsNetworkBusinessOverview__clearedBubble--basicInfoTop">
            <Tooltips
              disableMouseHover
              content="New newsroom accounts created with TMX."
              direction="bottom">
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopTitle">
                {responseData?.messenger?.bp_users}
              </h1>
              <h1 className="tmx-analyticsNetworkBusinessOverview__basicInfoTopSubTitle">
                {overallDataSetType === 'This Day'
                  ? 'Daily'
                  : overallDataSetType === 'This Week'
                  ? 'Weekly'
                  : 'Monthly'}{' '}
                Total Business pitches users
                <br />
                {/* (Unique) */}
              </h1>
            </Tooltips>
          </div>
        )}
      </div>
    </>
  );
};

AnalyticsNetworkBusinessOverview.propTypes = {};

export default AnalyticsNetworkBusinessOverview;
